import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { TARIFF_TAB } from '~/constants';
import ScenarioTemplateModel from '~/models/ScenarioTemplateModel';
import { IScenarioProxyComponent } from '~/screens/ScenariosScreen/types';
import ScenarioEditor from '../../../components/ScenarioEditor';
import Button from '../../../components/ui/Button';
import Drawer from '../../../components/ui/Drawer';
import Message from '../../../components/ui/Message';
import Spinner from '../../../components/ui/Spinner';
import Table from '../../../components/ui/Table';
import Toolbar from '../../../components/ui/Toolbar';
import ScenarioModel from '../../../models/ScenarioModel';
import { ScenariosTemplates } from '../ScenarioTemplates';

interface IScenarioList extends IScenarioProxyComponent {
  scenarioListColumns: object[];
}

export const ScenarioList = observer(({
  self,
  scenarioListColumns,
}: IScenarioList) => {
  const {
    availableScenarios,
    availableFeedbackScenarios,
    scenariosCount,
    isMessageShown,
    showMessage,
    hideMessage,
  } = self.store;


  useEffect(() => {
    console.log('use effect');
  }, [self.store.scenarios]);

  console.log('changed', self.store.availableScenarios);

  const scenarios = self.isFeedback
    ? self.store.feedbackScenarios
    : self.store.scenarios;
  const selectedScenario = scenarios.find(
    (scenario: ScenarioModel) =>
      scenario.get('id') === self.state.selectedScenario
  );
  const rowData = Array.from(
    self.isFeedback ? availableFeedbackScenarios : availableScenarios
  );


  const sortedRowData = rowData.sort(
    // @ts-ignore
    (a, b) => Number(b.get('created_date')) - Number(a.get('created_date'))
  );

  const hideErrorMessage = () => {
    self.setState({ isErrorMessageVisible: false });
    self.setState({ isErrorWhenCheckScriptException: false });
  };

  const redirectToSettings = () => {
    const { history } = self.props;
    history.push(`/settings?tab=${TARIFF_TAB}`);
  };

  const msgPaymentError = () => {
    return (
      <>
        <div className="scenarios-screen-list__error-img">
          <img
            className="_error-block"
            src="assets/paymentError/payment-error.svg"
            alt=""
            width="200"
          />
        </div>
        <span className="_title">Платеж не прошел</span>
      </>
    );
  };

  const handleCloseScenario = () => {
    if (self.store.scenarioEditingStatus === 'edited') {
      self.setState({ selectedScenario: null });
    } else {
      self.store.setScenarioEditingStatus('editing');
    }
  };

  const handleClickRow = async (scenario: ScenarioModel) => {
    self.setState({ selectedScenario: scenario.get('id') });

    if (!scenario.template) {
      scenario.template = new ScenarioTemplateModel(self, {
        id: scenario.get('id'),
      });
    }

    await scenario.template.fetch();
  };

  // @ts-ignore
  return (
    <div className="scenarios-screen-list">
      <Toolbar
        className="scenarios-screen-list__toolbar"
        left={(
          <Button
            icon="Plus"
            onClick={
              scenariosCount.currentCount === scenariosCount.maxCount
                ? showMessage
                : self.handleClickCreate
            }
          >
            Создать виджет
          </Button>
        )}
      />

      <Table
        className="scenarios-screen-list__table scenarios-screen-list-table"
        columns={scenarioListColumns}
        rows={sortedRowData as object[]}
        rowKey={(scenario: ScenarioModel) => scenario.key}
        rowClassName={(scenario: ScenarioModel) =>
          `scenarios-screen-list-table__row _id-${scenario.key}`
        }
        rowHover
        onRowClick={handleClickRow}
      />
      {self.state.isErrorMessageVisible && (
        <Message
          visible={self.state.isErrorMessageVisible}
          className="scenarios-screen-list__msg-desc"
          title={msgPaymentError()}
          textTop="Работа сервиса приостановлена, т.к. подписка не была оплачена. Пожалйста, проверьте наличие денежных средств на карте, привязанной к вашей учетной записи. Сервис автоматически разблокируется после списания средств"
          applyText="OK"
          showLine={false}
          onApply={hideErrorMessage}
          onClose={hideErrorMessage}
          onExit={hideErrorMessage}
        />
      )}

      {self.state.isErrorWhenCheckScriptException && (
        <Message
          visible={self.state.isErrorWhenCheckScriptException}
          className="scenarios-screen-list__msg-script-exception"
          title={(
            <span>
              Если не подключить сайт, этот <br /> раздел не сможет работать 🙄
            </span>
            )}
          textTop="Подключайте сайт и пользуйтесь на здоровье!"
          applyText="Подключить сайт"
          cancelText="Закрыть"
          showLine={false}
          onApply={redirectToSettings}
          onClose={hideErrorMessage}
          onExit={hideErrorMessage}
        />
      )}

      <Drawer
        visible={!!self.state.selectedScenario}
        onClose={handleCloseScenario}
        title="Редактирование виджета"
        size="large"
        flexBody
      >
        {selectedScenario?.template?.isFetching && <Spinner />}
        {selectedScenario?.template?.isFetched && (
          <ScenarioEditor
            scenarioEditingStatus={self.store.scenarioEditingStatus}
            setScenarioEditingStatus={self.store.setScenarioEditingStatus}
            preset={selectedScenario.template.copy()}
            onClose={handleCloseScenario}
            onSave={self.handleSaveScenario}
          />
        )}
      </Drawer>
      {self.state.isTemplatesVisible && (
        <ScenariosTemplates self={self} />
      )}

      <Message
        title="Создано максимальное количество виджетов на тарифном плане"
        textTop="Чтобы создать новый виджет, необходимо удалить один существующий."
        applyText="OK"
        visible={isMessageShown}
        onApply={hideMessage}
        onClose={hideMessage}
        onExit={hideMessage}
      />
    </div>
  );
});
